module.exports = __webpack_public_path__ + "img/img-promo-inferior.9a167b50.svg";